import * as Sentry from '@sentry/browser';
import { enableMapSet } from 'immer';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { getIsModernLayout } from '@/utils/isModernLayout';

enableMapSet();

if (import.meta.env.PROD) {
  Sentry.init({
    enabled: import.meta.env.PROD, // not sure if this is necessary given the if statement
    dsn: 'https://fe310d235f0b47a08f7bc5a29c3e99b5@o4504362850975744.ingest.us.sentry.io/4504367689564160',

    // Alternatively, use `process.env.npm_package_version` for a dynamic release version
    // if your build tool supports it.
    release: `${__APP_NAME__}@${__APP_VERSION__}+${__APP_BUILD_NUMBER__}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.captureConsoleIntegration({ levels: ['error'] }),
    ],

    environment: import.meta.env.VITE_ENV,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [/^\/api\//],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

import(getIsModernLayout() ? './redesign/app/App' : './app/App').then(({ App }) => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
